import api from "../api/api";

export default {
  async getUserData(userId) {
    try {
      const { data } = await api.get(`/user/${userId}`);
      return data.user;
    } catch (error) {
      console.log(error);
    }
  },
};
